import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  GetAssetsMetadataGQL,
  GetAssetsMetadataQuery
} from '../../pools/pool/lib/services/assets/assets-metadata.generated';

@Injectable({ providedIn: 'root' })
export class AssetService {
  constructor(private assetsMetadataService: GetAssetsMetadataGQL) {}

  public async getTotalAssetMbSize(assetIds: string[]): Promise<number> {
    if (assetIds.length === 0) {
      return 0;
    }

    const metadata = await this.getMultiMetadata(assetIds);
    const assetByteSize = metadata.reduce((acc, m) => acc + (m.size ?? 0), 0);

    return Number.parseFloat((assetByteSize / (1000 * 1024)).toFixed(2));
  }

  private async getMultiMetadata(
    assetIds: string[]
  ): Promise<GetAssetsMetadataQuery['assetsMetadata']> {
    const result = await firstValueFrom(
      this.assetsMetadataService.fetch({ assetIds })
    );

    return result.data.assetsMetadata;
  }
}
